import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { DiagnosticPieceData } from "@/features/maintenance/features/workflows/types/forwardings/directiveEntries/diagnosticEntry/diagnosticEntry.type";
import { useQueryClient } from "@tanstack/react-query";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDeleteDiagnosticObjectivePiece } from "../../../../../../hooks/diagnosticObjectivePieces/useDeleteDiagnosticObjectivePiece";

interface DeleteDiagnosticObjectivePieceProps {
  diagnosticPiece: DiagnosticPieceData;
}

const DeleteDiagnosticObjectivePiece = ({
  diagnosticPiece
}: DeleteDiagnosticObjectivePieceProps) => {
  const { forwardingId } = useParams();

  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteActivity,
    isPending: deleteActivityIsPending,
  } = useDeleteDiagnosticObjectivePiece({
    diagnosticObjectivePieceId: diagnosticPiece.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwardingId] });

        setIsOpen(false);
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="link-white"
            operationKlassToCheckPermission="Establishment::Maintenance::DiagnosticObjectivePieces::Destroy"
          >
            <Trash2Icon strokeWidth={1} className="text-danger" />
          </Button>
        )}
        title="Você tem certeza?"
        subtitle="Essa peça será removida do seu orçamento"
        useCancellableFooter
        showClose={false}
        titleClass="text-2xl"
        subtitleClassName="text-sm mt-2"
        className="rounded-lg overflow-hidden"
        cancelButtonClassName="bg-white-100"
        onConfirm={deleteActivity}
        confirmButtonIsLoading={deleteActivityIsPending}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DeleteDiagnosticObjectivePiece;
